var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Dialogue',{attrs:{"is-visible":_vm.isVisible}},[_c('p',{staticClass:"is-bold text-center"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('p',{staticClass:"text-center"},[_vm._v(" "+_vm._s(_vm.message)+" ")]),_c('ButtonsContainer',[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }